import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import App from './App';
import './index.css';
import 'react-activity/dist/react-activity.css';
import 'react-notifications-component/dist/theme.css'
import 'react-flags-select/css/react-flags-select.css';
import 'react-phone-input-2/lib/style.css';

if (!localStorage.getItem("token") && window.location.pathname === "/" && window.location.hostname !== "localhost") {
  window.location.href = "https://home.wirebit.com";
} else {
  ReactDOM.render(
    <App />,
    document.getElementById('root')
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
